import React, { useRef, useEffect, useState} from 'react';
import {OutputGraph,OutputGraph_xy, OutputTable, fileFormats, DataDownload} from './output_graph.js';
import {get_Txy_data, get_y1_T, roundQuantity,} from './physical_models.js';

const CN=0, EN = 1;

export function VLE_theory({params}){

  const {selectedModel, selectedSystem, tMax, tMin, lang} = params;
  const FileFormatList = ['csvfile'];
  const [selectedFileFormat, setSelectedFormat] = useState('csvfile');

  const setting_cap = (lang===CN) ? '设定气压和液相摩尔组成' : 'Set pressure & liquid composition (molar)';
  const azeo_T_cap = (lang===CN) ? '恒沸温度' : 'Azeotropic T';
  const azeo_X_cap = (lang===CN) ? '恒沸组成' : 'Azeotropic x1';

  const press_unit_cn = 'bar', press_unit_en = 'bar';
  const press_unit = (lang===CN) ? press_unit_cn : press_unit_en;

  const txytitle_cap_cn = 'T-x-y 相图', txytitle_cap_en = 'T-x-y Phase Diagram';
  const txytitle_cap = (lang===CN) ? txytitle_cap_cn : txytitle_cap_en;
  const xytitle_cap_cn = 'x-y 相图', xytitle_cap_en = 'x-y Phase Diagram';
  const xytitle_cap= (lang===CN) ? xytitle_cap_cn : xytitle_cap_en;
  
  const calculateT_en = 'Get Results', calculateT_cn = '计算结果';
  const calculateT = (lang===CN) ? calculateT_cn : calculateT_en;

  const clear_data_cn='清除计算结果', clear_data_en = 'Clear All results';
  const clear_data = (lang===CN) ? clear_data_cn:clear_data_en;
  const exportData_cn='导出计算结果', exportData_en='Export results';
  const exportData_cap = (lang===CN) ? exportData_cn:exportData_en;
  const download_but_cn='导出...', download_but_en='Export...';
  const download_but_cap = (lang===CN) ? download_but_cn:download_but_en;


  const [P_in, setP_in] = useState(1.013);
  const [x1_in, setX1_in] = useState('[0.0-1.0]');
  const [T_out, setT_out] = useState('NaN');
  const [y1_out,setY1_out] = useState('NaN');
  const [data, setData] = useState([]);
  // data = [{P: , x1: , y1: , Tb:}]
  
  const {Txy_data, Tm, xm, azeotrope} = get_Txy_data(P_in,selectedModel, selectedSystem);


  const P_in_Change = (e)=>{
    const newP = e.target.value;
    setP_in(newP);
    //handleClearData();

  } 
  const x1_in_Change = (e)=>{
    const newX1 = e.target.value;
    setX1_in(newX1);
  } 
  const onSelectedFormat = (e)=>{
    const newFormat = e.target.value;
    setSelectedFormat(newFormat);
  }

  const handleCalculateT = ()=>{ 
    let xn = parseFloat(x1_in), Pn = parseFloat(P_in);
    const alert_info_x = (lang===CN)? '请输入0-1之间的液相组成' : 'Please input a liquid composition btw 0 and 1.';
    const alert_info_P = (lang===CN)? '请输入0.1-10 bar之间的气压' : 'Please input a pressure btw 0.1 and 10 bar.'
    if (isNaN(xn) || xn > 1.0 || xn < 0.0 ) {
      alert(alert_info_x);
      return;
    };
    if (isNaN(Pn) || Pn > 10.0 || Pn < 0.1 ) {
      alert(alert_info_P);
      return;
    };    
    const ans = get_y1_T(P_in,x1_in, selectedModel, selectedSystem);
    setT_out(ans.T_bubble);
    setY1_out(ans.y1);
    const newData = [...data, {P: P_in, x1: x1_in, y1: ans.y1, Tb: ans.T_bubble, model:selectedModel, system:selectedSystem}];
    setData(newData);
    
  }

  const handleClearData = ()=>{
    setT_out('NaN');
    setY1_out('NaN');
    setX1_in('');
    setData([]);
   
  }

    return (
    
    <tr> 
      <td width='190px'>  
        <tr>
            {setting_cap} <br/><br/>

            <i>P</i><sub>0</sub> = <input type="number" step="0.1" min="0.1" max='10.0' placeholder='[0.1-10.0]' class='inputBox2' value={P_in} onChange={P_in_Change}/> {' '+press_unit}
            <br/>
            <i>x</i><sub>1</sub> = <input type="number" step="0.1" min="0.0" max='1.0' placeholder='[0.0-1.0]' class='inputBox3' value={x1_in} onChange={x1_in_Change}/> 
            <br/><br/>
            <button onClick={handleCalculateT}>{calculateT}</button> &nbsp;
            <br/><br/>
            <i>T</i><sub>b</sub> = <input class='inputBox1' value={roundQuantity(T_out-273.15,2)} readonly="true"/>&nbsp;<sup>o</sup>C
            <br/>
            <i>y</i><sub>1</sub> = <input class='inputBox1' value={roundQuantity(y1_out,2)} readonly="true"/>
            {(azeotrope!==0) &&  <div>{azeo_T_cap}: {(Tm-273.15).toFixed(2)}<sup>o</sup>C<br/>{azeo_X_cap}: {xm.toFixed(4)}</div>} 
  
        </tr>
    
        <tr>
          <br/> 
          <button onClick={handleClearData}>{clear_data}</button><br/>
        </tr>
    
      </td>   
    
      <td width='320px' align="center">
        <tr>{txytitle_cap}</tr>
        
        <tr>
        <OutputGraph bgData={Txy_data} data={data} tMax={tMax} tMin={tMin} lang={lang}/>
       </tr>
      </td>
    
      <td width='290px' align="center">
      
      <tr>{xytitle_cap}</tr>
      <tr>
        <OutputGraph_xy bgData={Txy_data} data={data} lang={lang}/>
      </tr>
      </td>

      <td width='200px'>
      <tr>
        <OutputTable data={data} lang={lang}/><br/>
      </tr>
      { (data.length>0) &&

        <tr align='left'>
            <br/>{exportData_cap}  <DataDownload data={data} prompt={download_but_cap} fileType={selectedFileFormat} lang={lang}/>
            {
              FileFormatList.map((s0)=>{ 
                  const format_name = (lang===CN)?fileFormats[s0].name_cn:fileFormats[s0].name_en;
                  const format_abbr = fileFormats[s0].abbr;
                  return (
                    <div>
                      <input type="radio" name="fileFormat" value={format_abbr} 
                      checked={(format_abbr===selectedFileFormat)?true:false} onClick={onSelectedFormat}/> {format_name}
                    </div>
              )
              })
            }
            <br/>
        </tr>

      }

      </td>
    </tr>
    )
    
    }